import { render } from "./App.vue?vue&type=template&id=d6db9eae"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d6db9eae&lang=css"

import exportComponent from "E:\\Apangu\\TdServerMiniAppPortalWeb\\TdServerMiniAppPortalWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__